import { Route } from 'react-router-dom';
import Home from './Home/Home';
import ProjectInfo from './ProjectInfo/ProjectInfo';
import ProjectType from './ProjectType/ProjectType';
import { DesignCondition } from './DesignCondition/DesignCondition';
import { Results } from './Results/Results';

export const endpoint = {
    home: '/',
    projectInfo: '/project-info',
    projectType: '/project-type',
    designCondition: '/designCondition/:projectType/:id',
    results: '/results/:projectType/:id',
};

export type TEndpoint = keyof typeof endpoint;

const commonRoutes = () => (
    <>
        <Route path={endpoint.home} element={<Home />} />
        <Route path={endpoint.projectInfo} element={<ProjectInfo />} />
        <Route path={endpoint.projectType} element={<ProjectType />} />
        <Route path={endpoint.designCondition} element={<DesignCondition />} />
        <Route path={endpoint.results} element={<DesignCondition />} />
    </>
);

export default commonRoutes();
